module.exports = __webpack_public_path__ + "static/media/bg.8d1bfa24.png";